import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useStyles } from "../../style/components/formStyle";
import { TextValidator } from "react-material-ui-form-validator";

//component: label + default input

const FormDefaultRow = ({ label, onChange, value, big }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid item className={`${big ? classes.rowBigRow : classes.row} ${classes.textableRow}`}>
      <Typography className={classes.label}>{t(label)}</Typography>
      <TextValidator
        className={classes.input}
        variant="outlined"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        validators={["required"]}
        errorMessages={["this field is required", "value is not valid"]}
      />
    </Grid>
  );
};

FormDefaultRow.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FormDefaultRow;
